import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function TermosDeUso() {
  useSEO({
    title: 'Termos de Uso - Moveideias',
    description: 'Termos de Uso do site institucional da Moveideias. Conheça as regras e condições para utilização do nosso site.',
    keywords: 'termos de uso, condições de uso, política, moveideias',
    canonical: '/termos-de-uso',
    schema: generateWebPageSchema({
      name: 'Termos de Uso',
      description: 'Termos de Uso do site institucional da Moveideias.',
      url: '/termos-de-uso',
    }),
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#221a32] to-[#3d2a5c] text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Termos de Uso
          </h1>
          <p className="text-xl text-gray-200">
            Site Institucional Moveideias
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="mb-8">
              <p className="text-gray-600 mb-4">
                <strong>Última atualização:</strong> 04 de novembro de 2025
              </p>
            </div>

            <div className="space-y-8">
              <div>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                  Bem-vindo(a) ao site institucional da MOVEIDEIAS!
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Estes Termos de Uso ("Termos") regem o seu acesso e uso do site da MOVEIDEIAS (https://www.moveideias.com.br), ou qualquer outro domínio que venha a ser utilizado pela MOVEIDEIAS e de todo o conteúdo informativo, materiais de marketing, notícias, artigos e informações de contato nele disponíveis.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Ao acessar ou utilizar qualquer parte do nosso site institucional, você concorda em cumprir e estar vinculado(a) a estes Termos, bem como à nossa Política de Privacidade. Caso não concorde com alguma condição aqui presente, por favor, não utilize nosso site.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  1. SOBRE A MOVEIDEIAS
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  A MOVEIDEIAS é uma empresa de transformação digital com o propósito de gerar transparência e valor por meio da informação nos processos logísticos das organizações. Nosso site institucional visa fornecer informações sobre nossa história, propósito, visão, valores, soluções (TeuPedido, MoveCourier, MovePipe) e modelo de negócios, atuando como um ponto de contato e apresentação da empresa.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  2. ACEITAÇÃO DOS TERMOS
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Ao acessar e navegar no site institucional da MOVEIDEIAS, você manifesta sua plena concordância com estes Termos de Uso e com a nossa Política de Privacidade. Se você estiver utilizando o site em nome de uma empresa ou outra entidade legal, você declara que tem autoridade para vincular essa entidade a estes Termos.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Estes Termos podem ser atualizados periodicamente. Quaisquer alterações serão publicadas nesta página. A sua continuidade no uso do site após a publicação de quaisquer alterações constitui a sua aceitação dessas alterações. Recomendamos que você revise estes Termos regularmente.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  3. CONTEÚDO DO SITE INSTITUCIONAL
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  O conteúdo disponível no site institucional da MOVEIDEIAS (textos, imagens, vídeos, artigos, notícias, etc.) tem caráter meramente informativo e educacional, e não deve ser interpretado como aconselhamento profissional, jurídico ou técnico específico. Embora nos esforcemos para manter as informações precisas e atualizadas, a MOVEIDEIAS não garante a exatidão, integridade ou atualidade de todo o conteúdo.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  4. PROPRIEDADE INTELECTUAL
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Todo o conteúdo disponível no site institucional, incluindo, mas não se limitando a textos, gráficos, logotipos, ícones, imagens, clipes de áudio, downloads digitais, slogans, marcas e outros materiais, são de propriedade exclusiva da MOVEIDEIAS ou de seus licenciadores, protegidos pelas leis brasileiras e internacionais de propriedade intelectual.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Você está autorizado(a) a visualizar, baixar e imprimir cópias do conteúdo do site apenas para seu uso pessoal e não comercial, desde que não modifique o material e mantenha todos os avisos de direitos autorais e propriedade. Qualquer outro uso, incluindo a reprodução, modificação, distribuição, transmissão, republicação, exibição ou execução do conteúdo para fins comerciais, é estritamente proibido sem a prévia autorização expressa por escrito da MOVEIDEIAS.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  5. CONDUTA DO USUÁRIO
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Ao utilizar o site institucional, você concorda em:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Utilizá-lo de forma legal, ética e respeitosa.</li>
                  <li>Não realizar qualquer ação que possa comprometer a segurança ou a integridade do site, como ataques de negação de serviço, inserção de código malicioso ou acesso não autorizado a sistemas.</li>
                  <li>Não coletar ou armazenar dados pessoais de outros usuários do site sem o seu consentimento.</li>
                  <li>Não enviar mensagens não solicitadas ("spam") ou qualquer outro material promocional não autorizado.</li>
                  <li>Não se passar por outra pessoa ou entidade.</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  A MOVEIDEIAS reserva-se o direito de monitorar o uso do site e tomar as medidas cabíveis em caso de violação destes Termos.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  6. LINKS PARA SITES DE TERCEIROS
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  O site institucional da MOVEIDEIAS pode conter links para sites de terceiros que não são operados ou controlados pela MOVEIDEIAS. Estes links são fornecidos apenas para sua conveniência. A MOVEIDEIAS não tem controle sobre o conteúdo, políticas de privacidade ou práticas de quaisquer sites ou serviços de terceiros e não assume qualquer responsabilidade por eles.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Recomendamos que você revise os Termos de Uso e as Políticas de Privacidade de quaisquer sites de terceiros que você visitar.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  7. EXCLUSÃO DE GARANTIAS
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  O site institucional da MOVEIDEIAS é fornecido "como está" e "conforme disponível", sem garantias de qualquer tipo, expressas ou implícitas. A MOVEIDEIAS não garante que o site será ininterrupto, livre de erros, seguro ou que qualquer defeito será corrigido.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  8. LIMITAÇÃO DE RESPONSABILIDADE
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Na extensão máxima permitida pela lei aplicável, a MOVEIDEIAS, seus diretores, funcionários, parceiros e afiliados não serão responsáveis por quaisquer danos diretos, indiretos, incidentais, especiais, consequenciais ou exemplares, incluindo, mas não se limitando a danos por lucros cessantes, perda de dados ou qualquer outra perda intangível, resultantes do uso ou da incapacidade de usar o site institucional, mesmo que a MOVEIDEIAS tenha sido avisada da possibilidade de tais danos.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  9. MODIFICAÇÕES DOS TERMOS DE USO
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  A MOVEIDEIAS reserva-se o direito de modificar, a seu exclusivo critério, estes Termos de Uso do Site Institucional a qualquer momento. Quaisquer alterações entrarão em vigor imediatamente após a sua publicação nesta página. A continuidade do uso do site após a publicação das modificações constituirá a aceitação das mesmas.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  10. LEI APLICÁVEL E FORO
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Estes Termos de Uso serão regidos e interpretados de acordo com as leis da República Federativa do Brasil. Para a resolução de quaisquer disputas decorrentes destes Termos, as partes elegem o Foro da Comarca de Porto Alegre, estado do Rio Grande do Sul, com exclusão de qualquer outro, por mais privilegiado que seja.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#221a32] mb-4">
                  11. CONTATO
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Se você tiver dúvidas sobre estes Termos de Uso ou sobre o site institucional da MOVEIDEIAS, entre em contato conosco através dos canais de atendimento disponíveis em nosso site ou pelo e-mail: privacidade@moveideias.com.br
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg mt-12">
                <h3 className="text-lg font-semibold text-[#221a32] mb-3">
                  Informações de Contato
                </h3>
                <p className="text-gray-700">
                  Para dúvidas sobre estes Termos de Uso, entre em contato através dos canais disponíveis em nosso site ou pelo e-mail: <strong>privacidade@moveideias.com.br</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
